import MaterialChip from "../../../../__snowpack__/pkg/@mui/material/Chip.js";
import styled from "styled-components";
import {IconContainer} from "../icon/icon.styles.js";
export const ChipContainer = styled(MaterialChip).withConfig({
  displayName: "chipstyles__ChipContainer",
  componentId: "sc-1ejz16u-0"
})(["", "{margin:0 5px 0 -6px;}"], IconContainer);
